import React, { useState, useEffect } from 'react';
import { useIdleTimer } from 'react-idle-timer';
import axios from 'axios';
import AlertDialog from '../common/AlertDialog';
import {stringConstants} from '../constants/stringConstants';
import {IDLE_SESSION_SETTING} from '../constants/applicationConstants';
import LocalStorageService from '../services/localStorage';
const localStorageService = LocalStorageService.getService();


import { useStoreActions } from 'easy-peasy';

const IdleTracker = () => {

  const debugMode = false;

  const loginAction = useStoreActions((actions) => actions.login);

  const commonAction = useStoreActions((actions) => actions.common);

  const timeout = IDLE_SESSION_SETTING.timeout // Show alert after this interval
  const BUFFER_TIME = IDLE_SESSION_SETTING.bufferTime; // Countdown after popup is displayed and before a use is auto logged out if no action is taken
  const BUFFER_TIME_INTERVAL = IDLE_SESSION_SETTING.bufferTimeInterval; // The interval for running the buffer time check 

  const idleSessionTimerInterval = IDLE_SESSION_SETTING.idleSessionTimerInterval;

  const [remaining, setRemaining] = useState(timeout);
  const [elapsed, setElapsed] = useState(0);
  const [isIdle, setIsIdle] = useState(false);
  const [showTimeoutAlert, setShowTimeoutAlert] = useState(false);
  const [bufferTimerId, setBufferTimerId] = useState(null);

  const [bufferTimeLeft, setBufferTimeLeft] = useState(BUFFER_TIME);

  function msToTime(duration) {
    let seconds = Math.floor((duration / 1000) % 60),
      minutes = Math.floor((duration / (1000 * 60)) % 60);
  
    minutes = (minutes < 10) ? "0" + minutes : minutes;
    seconds = (seconds < 10) ? "0" + seconds : seconds;

    let returnStr = '';

    if (minutes > 0) {
      returnStr += minutes + " minutes ";
    }

    returnStr += seconds + " seconds";
  
    return returnStr;
  }
  
  const handleLogout = async () => {
    await loginAction.logout();
    handleReset();
    window.location = '/';    
  }

  /* const logout = () => {
    const baseUrl = process.env.REACT_APP_API_URL;
    axios.post(`${baseUrl}/users/logout`, { 
      "token": localStorage.getItem('refreshToken'),
      "client_id": localStorage.getItem('clientID')
    })
    .then((res) => {
      LocalStorageService.clearToken();
      setTimeout(function () {
        window.location = '/login';
      }, 1000);
    });
  } */

  const generateTokenForUser = async () => {
    const baseUrl = process.env.REACT_APP_API_URL;
    await axios
    .post(`${baseUrl}/users/generate-token`, {
      refreshToken: localStorage.getItem('refreshToken'),
      client_id: localStorage.getItem('clientID'),
    })
    .then((res) => {
      if (
        (res?.data?.data?.error &&
          res.data.data.error.toUpperCase().replace(/[ _]/g, '-') ===
            'NOTAUTHORIZEDEXCEPTION:-INVALID-REFRESH-TOKEN') ||
        (res?.data?.data?.error &&
          res.data.data.error.toUpperCase().replace(/[ _]/g, '-') ===
            'NOTAUTHORIZEDEXCEPTION:-REFRESH-TOKEN-HAS-EXPIRED')
      ) {
        commonAction.setSubmitSnackbar({
          status: true,
          messages: res.data.data.error,
        });
        handleLogout();
      } else {
        if (res.data.data.AuthenticationResult?.AccessToken) {
          localStorage.setItem(
            'accessToken',
            res.data.data.AuthenticationResult.AccessToken,
          );
          localStorage.setItem(
            'tokenTimestamp',
            Date.now(),
          );
        }
      }
    })
    .catch((err) => {
      // handleLogout();
      LocalStorageService.clearToken();
      setTimeout(function () {
        window.location = '/login';
      }, 500);
    });
  }

  const alertDialogOpts = {
    title: stringConstants.IDLE_ALERT_POPUP_TITLE,
    description: stringConstants.IDLE_ALERT_POPUP_BODY.replace('%time_left%', msToTime(bufferTimeLeft)),
    btnOkText: "Ok",
    btnCancelText: "Cancel",
    onClose: (selectedValue) => {
      if (selectedValue) {
        handleReset();
        setShowTimeoutAlert(false);
      }
      else {
        // Logout user
        handleReset();
        setShowTimeoutAlert(false);        
        handleLogout();
      }
    },
  };

  const handleOnActive = () => setIsIdle(false);
  const handleOnIdle = () => {
    setIsIdle(true)
  };

  const {
    reset,
    getRemainingTime,
    getElapsedTime
  } = useIdleTimer({
    timeout,
    onActive: handleOnActive,
    onIdle: handleOnIdle,
    crossTab: true
  })

  const handleReset = () => reset();

  useEffect(() => {
    setRemaining(getRemainingTime())
    setElapsed(getElapsedTime())

    setInterval(() => {
      setRemaining(getRemainingTime())
      setElapsed(getElapsedTime())

      // If user is not idle and the user current accessToken is 45 mins past since its creation, generate a new token for him
      if (!isIdle && (Date.now() >= parseInt(localStorageService.getTokenTimestamp()) + 1000 * 60 * 45) ) {
        // generate a new accessToken for the user
          generateTokenForUser();

      }
      
    }, idleSessionTimerInterval)

  }, []);


  useEffect(() => {
   
    // If user has gone idle, display Alert
   if ( isIdle && !showTimeoutAlert && remaining==0 ) {
      setShowTimeoutAlert(true);
    }
    
  }, [elapsed]);

  useEffect(() => {
   
    if (showTimeoutAlert) {

      if (bufferTimerId == null) {

        let t = BUFFER_TIME;

        const intervalId = setInterval(() => {

          t = t-BUFFER_TIME_INTERVAL;

          setBufferTimeLeft(t);
    
          if (t <= 0 ) { // Buffer time is up, auto logout the user
            clearInterval(bufferTimerId);
            if(localStorage.getItem('refreshToken') && localStorage.getItem('refreshToken').length > 0 && localStorage.getItem('clientID')) {
              handleLogout();
              setShowTimeoutAlert(false);
            }
          }
            
        }, BUFFER_TIME_INTERVAL);

        setBufferTimerId(intervalId);

      }

    }
    else if (bufferTimerId) {
      clearInterval(bufferTimerId);
      setBufferTimerId(null);
    }

  }, [showTimeoutAlert]);

  return (
    <>
        {debugMode && (<div><br />
          <br /><br />
          <p>Timeout: {timeout}ms</p>
          <p>Time   Remaining: {remaining}</p>
          <p>Time Elapsed: {elapsed}</p>
          <p>Idle: {isIdle.toString()}</p>
        </div>)}

        <AlertDialog opts={alertDialogOpts} open={showTimeoutAlert}></AlertDialog>
    </>
  )
  
};

export default IdleTracker;